import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Row, Col, Grid, Tabs } from 'antd'
import Filter from './Filter'
import Lane from './Lane'
import RenderWarper  from './render.style'

const { useBreakpoint } = Grid
const { TabPane } = Tabs

const laneHeaders = {
  pending: 'รอเสนอราคา',
  client_review: 'รอลูกค้าตัดสินใจ',
  done: 'จบงาน'
}

const DealsBoardRender = ({ categorySelectorProps, onChangeCategory = () => {} }) => {
  const [filters, setFilters] = useState({})
  const screens = useBreakpoint()
  const isMobile = !screens.sm

  const onChangeFilters = (args) => {
    setFilters({ ...filters, ...args })
  }

  useEffect(() => {
    onChangeCategory(filters.categoryId)
  }, [filters.categoryId])

  return (
    <RenderWarper>
      <Filter
        categorySelectorProps={categorySelectorProps}
        onChangeFilters={onChangeFilters} />
      {isMobile ? (
        <Tabs defaultActiveKey="pending" className="lanes-tabs">
          <TabPane tab={laneHeaders.pending} key="pending">
            <Lane state='pending' otherFilters={filters} />
          </TabPane>
          <TabPane tab={laneHeaders.client_review} key="client_review">
            <Lane state='client_review' otherFilters={filters} />
          </TabPane>
          <TabPane tab={laneHeaders.done} key="done">
            <Lane state='done' otherFilters={filters} />
          </TabPane>
        </Tabs>
      ) : (
        <Row gutter={[8, 0]} >
          <Col span={8}>
            <Lane state='pending' otherFilters={filters} />
          </Col>
          <Col span={8}>
            <Lane state='client_review' otherFilters={filters} />
          </Col>
          <Col span={8}>
            <Lane state='done' otherFilters={filters} />
          </Col>
        </Row>
      )}
    </RenderWarper>
  )
}

DealsBoardRender.propTypes = {
  categorySelectorProps: PropTypes.object,
  onChangeCategory: PropTypes.func
}

export default DealsBoardRender
